export default function Go_Integer () {
  return (
    <div>
      <h1>Go_Integer </h1>
      <p>Integer</p>
    </div>
  );
}